import { lazy } from "react";

const routes = [
  {
    path: "/change-password",
    element: lazy(() => import("../pages/ChangePassword")),
  },
];

export default routes;
